var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.draft)?_c('small',{staticClass:"bg-light text-danger p-1"},[_c('b-icon-eye-slash',{attrs:{"aria-hidden":"true"}}),_vm._v(" Brouillon")],1):_c('small',{staticClass:"bg-success text-white p-1 pr-3"},[_c('strong',[_c('b-icon-check',{attrs:{"aria-hidden":"true"}}),_vm._v(" Publié")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }